<script setup lang="ts">
import LeTooltip from "@dsk/components/LeTooltip.vue";
import LeView from "@dsk/icons/LeView.vue";
import { useI18n } from "vue-i18n";

import type { Dictionary, SearchViewType } from "@/types";

import LeUpsellAccessRequestModalStateButton from "./LeUpsellAccessRequestModalStateButton.vue";

const props = defineProps<{
  searchViewType: SearchViewType;
  dictionary: Dictionary;
}>();

const { t } = useI18n();
</script>

<template>
  <div class="le-upsell-prefix" :class="{ [`le-upsell-prefix--${props.searchViewType}`]: true }">
    <div class="le-upsell-prefix__content">
      <LeView role="presentation" class="le-upsell-prefix__icon" />
      <i18n-t tag="span" class="le-upsell-prefix__text" keypath="le-upsell.prefix.text">
        <template #dictionary>
          <LeTooltip :text="t('le-upsell.button.get-access')" :margin-bottom="5">
            <LeUpsellAccessRequestModalStateButton
              :dictionary="props.dictionary"
              :search-view-type="props.searchViewType"
              type="text-button"
              class="le-upsell-prefix__text--button"
              tracking-context="prefix"
            >
              {{ props.dictionary.title }}
            </LeUpsellAccessRequestModalStateButton>
          </LeTooltip>
        </template>
      </i18n-t>
    </div>
  </div>
</template>

<style scoped lang="less">
@import "@dsk/styles/all";

.le-upsell-prefix {
  margin-bottom: -3px;
  border-radius: 4px 4px 0px 0px;
  background-color: @colors[@accent][100];

  &--classic {
    padding: 8px 8px 11px;

    #media-breakpoint-up(md, {
      padding: 10px 30px 13px;
    });
  }

  &--compact {
    padding: 8px 18px 11px;
  }

  &__content {
    display: inline-flex;
    align-items: flex-start;
    gap: 10px;
  }

  &__icon {
    margin-top: 4px;
  }

  &__text {
    .body-text("m");
    color: @colors[@neutrals][300];

    :deep(&--button) {
      .body-text("m", "semi-bold");
      text-decoration: underline;

      &.focus-visible {
        border-radius: 4px;
        .focus-outline(yellow);
      }
    }
  }
}
</style>
